
function toggleCalorieCalculatorForm() {
    const form = document.getElementById('calorieCalculatorForm');
    const button = document.querySelector('.CalorieCalculatorBtn');
    const container = document.querySelector('.calorie-calculator-container');
    const tabButtons = document.getElementsByClassName('tablink');

    form.classList.toggle('open');
    button.style.display = 'none';

    // Hide Tab2 and Tab3
    document.getElementById('Tab2').style.display = 'none';
    document.getElementById('Tab3').style.display = 'none';

    // Activate Tab1
    for (let i = 0; i < tabButtons.length; i++) {
        const tabButton = tabButtons[i];

        if (tabButton.textContent === 'Tab 1') {
            openTab('Tab1', tabButton);
            break;
        }
    }

    // Add tab_open_1 class to container
    container.classList.add('tab_open_1');
}

function openTab(pTabName, pButton, pPressedNext) {
    const tabContent = document.getElementsByClassName("tabcontent");
    const tabButtons = document.getElementsByClassName("tablink");
    const container = document.querySelector(".calorie-calculator-container");
    const containerInner = document.getElementById("containerInner");
    const fieldsError = document.getElementById("FieldsError");
    const relatedProducts = document.getElementById("related-products");
    container.scrollIntoView();
    containerInner.style.borderRadius = "10px 10px 0 0";

    if (fieldsError) {
        fieldsError.style.display = "none";
    }

    const age = document.getElementById("age");
    const weight = document.getElementById("weight");
    const height = document.getElementById("height");

    let allAreFilled = true;

    let currentTab = -1;
    switch (pTabName) {
        case "Tab1":
            break;
        case "Tab2":
            currentTab = 1;
            break;
        case "Tab3":
            currentTab = 2;
            break;
    }

    if (currentTab > 0) {
        let ageValue = age.value;
        let weightValue = weight.value;
        let heightValue = height.value;

        if (ageValue < 0 || ageValue > 120 || ageValue === "") {
            allAreFilled = false;
            fieldsError.style.display = "block";
            fieldsError.querySelector("p").textContent = age.dataset.textError;
        } else if (weightValue < 20 || weightValue > 300) {
            allAreFilled = false;
            fieldsError.style.display = "block";
            fieldsError.querySelector("p").textContent = weight.dataset.textError;
        } else if (heightValue < 100 || heightValue > 240) {
            allAreFilled = false;
            fieldsError.style.display = "block";
            fieldsError.querySelector("p").textContent = height.dataset.textError;
        }
    }

    if (!allAreFilled && currentTab > 0) {
        showError(fieldsError, function() {
            setTimeout(function() {
                hideError(fieldsError);
            }, 2000);
        });

        function showError(el, callback) {
            el.style.display = "block";
        }

        function hideError(el) {
            el.style.display = "none";
        }

    } else {
        for (let i = 0; i < tabContent.length; i++) {
            tabContent[i].style.display = "none";
            tabButtons[i].classList.remove("active");
        }

        document.getElementById(pTabName).style.display = "block";
        pButton.classList.add("active");
        container.classList.remove("tab_open_1", "tab_open_2", "tab_open_3");

        switch (pTabName) {
            case "Tab1":
                container.classList.add("tab_open_1");
                relatedProducts.style.display = "none";
                break;
            case "Tab2":
                container.classList.add("tab_open_2");
                relatedProducts.style.display = "none";
                break;
            case "Tab3":
                container.classList.add("tab_open_3");
                relatedProducts.style.display = "block";
                break;
        }
    }
}

function calculateBMI(weight, height) {
return weight / ((height / 100) * (height / 100));
}

function determineBMIFactor(bmi) {
if (bmi >= 30) return 0.8;
if (bmi >= 26 && bmi < 30) return 0.9;
return 1.0;
}

function calculateNutrition(age, weight, height, gender, activity, goal) {
    // Constants
    const CALORIES_PER_GRAM_PROTEIN = 4;
    const CALORIES_PER_GRAM_FAT = 9;
    const CALORIES_PER_GRAM_CARB = 4;

    // Calculate BMR (Mifflin-St Jeor Equation)
    let bmr;
    if (gender === 'female') {
        bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    } else {
        bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    }
    
    const activityFactor = activity
    const tdee = bmr * activityFactor;

    // Calculate caloric intake based on goal
    let targetCalories;
    switch (goal) {
        case 'wl':
            targetCalories = tdee - 500; // 500 calorie deficit for weight loss
            break;
        case 'dbh':
            targetCalories = tdee;
            break;
        case 'dry':
            targetCalories = tdee + 250; // 250 calorie surplus for muscle gain
            break;
        case 'gain':
            targetCalories = tdee + 500; // 500 calorie surplus for weight gain
            break;
        default:
            targetCalories = tdee;
            break;
    }

    // Calculate macronutrient needs
    function calculateMacronutrients(targetCalories, proteinRatio, fatRatio) {
        const proteinGrams = proteinRatio * weight;
        const caloriesFromProtein = proteinGrams * CALORIES_PER_GRAM_PROTEIN;
        const caloriesFromFat = targetCalories * fatRatio;
        const fatGrams = caloriesFromFat / CALORIES_PER_GRAM_FAT;
        const caloriesFromCarbs = targetCalories - (caloriesFromProtein + caloriesFromFat);
        const carbGrams = caloriesFromCarbs / CALORIES_PER_GRAM_CARB;

        return {
            targetCalories,
            proteinGrams,
            fatGrams,
            carbGrams
        };
    }

    let macronutrients;
    switch (goal) {
        case 'wl':
            macronutrients = calculateMacronutrients(targetCalories, 1.4, 0.3); // 1.4g/kg protein, 30% fat
            break;
        case 'dbh':
            macronutrients = calculateMacronutrients(targetCalories, 1.1, 0.3); // 1.1g/kg protein, 30% fat
            break;
        case 'dry':
            macronutrients = calculateMacronutrients(targetCalories, 1.8, 0.3); // 1.8g/kg protein, 30% fat
            break;
        case 'gain':
            macronutrients = calculateMacronutrients(targetCalories, 1.2, 0.25); // 1.2g/kg protein, 25% fat
            break;
        default:
            macronutrients = calculateMacronutrients(targetCalories, 1.1, 0.3); // Default to maintain weight ratios
            break;
    }

    return {
        bmr,
        tdee,
        targetCalories,
        macronutrients
    };
}


function calculateCalories() {
const gender = document.getElementById("gender").value;
const age = parseInt(document.getElementById("age").value);
const weight = parseInt(document.getElementById("weight").value);
const height = parseInt(document.getElementById("height").value);
const activity = parseFloat(document.getElementById("activity").value);
const goal = document.getElementById("goal").value;

// Calculate original BMR
const bmr = calculateBMR(gender, age, weight, height);

// Calculate BMI and determine BMI-factor
//const bmi = calculateBMI(weight, height);
//const bmiFactor = determineBMIFactor(bmi);

// Adjust BMR with BMI-factor
//const adjustedBMR = bmr * bmiFactor;
  const adjustedBMR = bmr; 

// Calculate other values using adjusted BMR
// const adjustedWM = calculateWM(adjustedBMR, activity);
// const adjustedWL = calculateWL(adjustedBMR, activity);
// const adjustedDry = calculateDry(adjustedBMR, activity);
// const adjustedGain = calculateGain(adjustedBMR, activity);


// Calculated results
const result = calculateNutrition(age, weight, height, gender, activity, goal);
console.log("calculated resulst here",result);
// Display results
//displayResultsOld(adjustedBMR, adjustedWM, adjustedWL, adjustedDry, adjustedGain, weight, goal);
  displayResults(result);
}


async function postData(url = "", data = {}) {
    const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: JSON.stringify(data),
    });
    return response.json();
}

function calculateBMR(gender, age, weight, height) {
    // const start = gender === "male" ? 88.362 : 447.593;
    // const calcWeight = gender === "male" ? 13.397 : 9.247;
    // const calcHeight = gender === "male" ? 4.799 : 3.098;
    // const calcAge = gender === "male" ? 5.677 : 4.33;
     //console.log(start + (calcWeight * weight) + (calcHeight * height)- (calcAge * age), 'bmr');
    //return start + (calcWeight * weight) + (calcHeight * height)- (calcAge * age);
   // let bmr;
    if (gender === 'female') {
        return 10 * weight + 6.25 * height - 5 * age - 161;
    } else {
        return 10 * weight + 6.25 * height - 5 * age + 5;
    }
  }

function calculateWM(bmr, activity) {
    return Math.round(bmr * activity);
}

function calculateWL(bmr, activity) {
    return Math.round(bmr * activity * 0.8);
}

function calculateDry(bmr, activity) {
    return Math.round(bmr * activity * 1.1);
}

function calculateGain(bmr, activity) {
    return Math.round(bmr * activity * 1.2);
}

function getGoalResultsForGadget(bmr, weight, goal) {
    return {
        'kcal': Math.round(bmr),
        'fat_in_gram': calculateFat(weight, goal),
        'carbs_in_gram': calculateCarbs(bmr, weight, goal),
        'protein_in_gram': calculateProtein(weight)
    };
}

function displayResults(result){
  var e = document.getElementById("goal");
  var value = e.options[e.selectedIndex].value;
  var goal = e.options[e.selectedIndex].text;
  
  const resultContainer = document.getElementById("resultContainer");
  resultContainer.innerHTML = '';

  resultContainer.innerHTML += `
      <div class="result-card black gold-bg" data-calorie="${Math.round(result.targetCalories)} kcal" data-fat="${Math.round(result.macronutrients.fatGrams)} G" data-carbohydrate="${Math.round(result.macronutrients.carbGrams)} G" data-protein="${Math.round(result.macronutrients.proteinGrams)} G">
          <span class="h5">${goal}</span>
          <div class="results" >
              <span class="bmr">${Math.round(result.targetCalories)} kcal</span>
              <ul>
                  <li>Vet: ${Math.round(result.macronutrients.fatGrams)} G</li>
                  <li class="123">Koolhydraten: ${Math.round(result.macronutrients.carbGrams)} G</li>
                  <li>Eiwitten: ${Math.round(result.macronutrients.proteinGrams)} G</li>
              </ul>
          </div>
      </div>
  `;

  resultContainer.innerHTML += `
        <div class="result-card black back-btn-container">
            <div class="results again_button">
                <button class="button button--secondary button--icon" onclick="location.reload()">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                    <path d="M23.6518 12.2868C23.2051 11.2467 22.6045 10.3494 21.8502 9.59505C21.0957 8.8407 20.1985 8.23981 19.1583 7.79332C18.1182 7.34643 17.027 7.12312 15.8844 7.12312C14.8078 7.12312 13.7659 7.3262 12.7586 7.73277C11.7515 8.13867 10.8558 8.71246 10.0724 9.45224L8.64389 8.03484C8.42409 7.80775 8.17151 7.75651 7.88577 7.88097C7.59274 8.00557 7.44629 8.22174 7.44629 8.52933V13.4514C7.44629 13.6418 7.51587 13.8066 7.65504 13.9457C7.79434 14.0849 7.95912 14.1545 8.14953 14.1545H13.0716C13.3793 14.1545 13.5953 14.008 13.7198 13.715C13.8443 13.4294 13.793 13.1767 13.5659 12.9569L12.0607 11.4407C12.5736 10.9573 13.1595 10.5857 13.8192 10.3255C14.4785 10.0655 15.1669 9.93541 15.8847 9.93541C16.6464 9.93541 17.3734 10.0839 18.0652 10.3804C18.7574 10.6771 19.356 11.0781 19.8614 11.5835C20.3668 12.0888 20.7679 12.6876 21.0645 13.3798C21.3611 14.0719 21.5094 14.7988 21.5094 15.5603C21.5094 16.3222 21.3611 17.049 21.0645 17.7408C20.7679 18.433 20.3668 19.0317 19.8614 19.5371C19.356 20.0426 18.7572 20.4436 18.0652 20.7401C17.373 21.0368 16.6459 21.1851 15.8847 21.1851C15.013 21.1851 14.1891 20.9947 13.4126 20.6139C12.6363 20.2331 11.9808 19.6948 11.4461 18.9988C11.3948 18.9256 11.3112 18.8815 11.1934 18.8668C11.0835 18.8668 10.9919 18.8997 10.9187 18.9656L9.41348 20.4819C9.35496 20.5407 9.32381 20.6155 9.32017 20.7071C9.31652 20.7988 9.34039 20.8811 9.39164 20.9543C10.1901 21.9211 11.1568 22.6701 12.2921 23.201C13.4274 23.7319 14.625 23.9976 15.8848 23.9976C17.0274 23.9976 18.1187 23.7741 19.1588 23.3274C20.1989 22.8806 21.0959 22.2799 21.8506 21.5256C22.6049 20.771 23.2058 19.874 23.6523 18.8339C24.0991 17.7938 24.3224 16.7023 24.3224 15.5599C24.3224 14.4172 24.0989 13.3262 23.6522 12.2861" fill="#C8A94C"/>
                </svg>
                Opnieuw berekenen</button>
            </div>
        </div>
    `;
}

function displayResultsOld(bmr, wm, wl, dry, gain, weight, goal) { 
    const resultContainer = document.getElementById("resultContainer");
    resultContainer.innerHTML = '';

    const blocks = [
        { goal: 'bmr', bmr: bmr, label: `BMR (Basal Metabolic Rate): ` },
        { goal: 'dbh', bmr: wm, label: `Onderhoud` },
        { goal: 'wl', bmr: wl, label: `Afvallen` },
        { goal: 'dry', bmr: dry, label: `Spieropbouw` },
        { goal: 'gain', bmr: gain, label: `Aankomen` }
    ];

   
  
    blocks.forEach((block) => {
        const blockClass = block.goal === goal ? 'black gold-bg' : 'black';
        resultContainer.innerHTML += `
            <div class="result-card ${blockClass}" data-calorie="${Math.round(block.bmr)} kcal" data-fat="${calculateFat(weight, block.goal)} G" data-carbohydrate="${calculateCarbs(block.bmr, weight, block.goal)} G" data-protein="${calculateProtein(weight)} G">
                <span class="h5">${block.label}</span>
                <div class="results" >
                    <span class="bmr">${Math.round(block.bmr)} kcal</span>
                    <ul>
                        <li>Vet: ${calculateFat(weight, block.goal)} G</li>
                        <li class="123">Koolhydraten: ${calculateCarbs(block.bmr, weight, block.goal)} G</li>
                        <li>Eiwitten: ${calculateProtein(weight)} G</li>
                    </ul>
                </div>
            </div>
        `;
    });

    resultContainer.innerHTML += `
        <div class="result-card black back-btn-container">
            <div class="results again_button">
                <button class="button button--secondary button--icon" onclick="location.reload()">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                    <path d="M23.6518 12.2868C23.2051 11.2467 22.6045 10.3494 21.8502 9.59505C21.0957 8.8407 20.1985 8.23981 19.1583 7.79332C18.1182 7.34643 17.027 7.12312 15.8844 7.12312C14.8078 7.12312 13.7659 7.3262 12.7586 7.73277C11.7515 8.13867 10.8558 8.71246 10.0724 9.45224L8.64389 8.03484C8.42409 7.80775 8.17151 7.75651 7.88577 7.88097C7.59274 8.00557 7.44629 8.22174 7.44629 8.52933V13.4514C7.44629 13.6418 7.51587 13.8066 7.65504 13.9457C7.79434 14.0849 7.95912 14.1545 8.14953 14.1545H13.0716C13.3793 14.1545 13.5953 14.008 13.7198 13.715C13.8443 13.4294 13.793 13.1767 13.5659 12.9569L12.0607 11.4407C12.5736 10.9573 13.1595 10.5857 13.8192 10.3255C14.4785 10.0655 15.1669 9.93541 15.8847 9.93541C16.6464 9.93541 17.3734 10.0839 18.0652 10.3804C18.7574 10.6771 19.356 11.0781 19.8614 11.5835C20.3668 12.0888 20.7679 12.6876 21.0645 13.3798C21.3611 14.0719 21.5094 14.7988 21.5094 15.5603C21.5094 16.3222 21.3611 17.049 21.0645 17.7408C20.7679 18.433 20.3668 19.0317 19.8614 19.5371C19.356 20.0426 18.7572 20.4436 18.0652 20.7401C17.373 21.0368 16.6459 21.1851 15.8847 21.1851C15.013 21.1851 14.1891 20.9947 13.4126 20.6139C12.6363 20.2331 11.9808 19.6948 11.4461 18.9988C11.3948 18.9256 11.3112 18.8815 11.1934 18.8668C11.0835 18.8668 10.9919 18.8997 10.9187 18.9656L9.41348 20.4819C9.35496 20.5407 9.32381 20.6155 9.32017 20.7071C9.31652 20.7988 9.34039 20.8811 9.39164 20.9543C10.1901 21.9211 11.1568 22.6701 12.2921 23.201C13.4274 23.7319 14.625 23.9976 15.8848 23.9976C17.0274 23.9976 18.1187 23.7741 19.1588 23.3274C20.1989 22.8806 21.0959 22.2799 21.8506 21.5256C22.6049 20.771 23.2058 19.874 23.6523 18.8339C24.0991 17.7938 24.3224 16.7023 24.3224 15.5599C24.3224 14.4172 24.0989 13.3262 23.6522 12.2861" fill="#C8A94C"/>
                </svg>
                Opnieuw berekenen</button>
            </div>
        </div>
    `;
}

function calculateFat(weight, goal) {
    let goalCalc = 0.8;
    switch(goal) {
        case 'dry':
            goalCalc = 1.1;
            break;
        case 'gain':
            goalCalc = 1.2;
            break;
    }
    return Math.round(weight * goalCalc);
}

function calculateProtein(weight) {
    return Math.round(weight * 2);
}

function calculateCarbs(calories, weight, goal) {
    let goalCalc = 7.2;
    switch(goal) {
        case 'dry':
            goalCalc = 9.9;
            break;
        case 'gain':
            goalCalc = 10.8;
            break;
    }
    console.log(Math.round( ( calories - (weight * 8) - (weight * goalCalc) ) / 4), 'calculateCarbs');
    return Math.round( ( calories - (weight * 8) - (weight * goalCalc) ) / 4);
}

function filterProducts() {
    const selectedGoal = document.getElementById("goal").value;
    const products = document.querySelectorAll("#filtered-products .product");
  console.log(selectedGoal,'selectedGoal');

    // products.forEach(function(product) {
    //     const productTags = product.getAttribute("data-tags");
    //     const showProduct = (selectedGoal === "wl" || selectedGoal === "dry") && productTags.includes("product-goal-wl") || (selectedGoal === "gain") && productTags.includes("product-goal-wg");
    //     console.log(showProduct,"showProduct");
    //     product.style.display = showProduct ? "flex" : "none";
    // });

    products.forEach(product => {
        const tags = product.getAttribute('data-tags').split(',');
        if (tags.includes(selectedGoal)) {
            console.log('here');
            product.style.display = 'block'; // Show the product
        } else {
          console.log('eles here');
            product.style.display = 'none'; // Hide the product
        }
    });
}

// scroll to top by default
window.onbeforeunload = function () { window.scrollTo(0, 0); }

document.getElementById("calorieCalculatorForm").addEventListener("submit", function(event) {
    event.preventDefault();
    calculateCalories();
});

const submitButton = document.querySelector('#calorieCalculatorCustomerForm button[type="submit"]');
const confirmAccount = document.querySelector('input[name="confirm_account"]');
const emailField = document.querySelector('input[name="email"]');

confirmAccount.addEventListener('change', function(event) {
    submitButton.disabled = !(event.target.checked && emailField.value.length > 6);
})

emailField.addEventListener('keyup', function(event) {
    submitButton.disabled = !(confirmAccount.checked && event.target.value.length > 6);
})

document.getElementById("calorieCalculatorCustomerForm").addEventListener("submit", function(event) {
    event.preventDefault();

    submitButton.innerHTML = submitButton.dataset.loadingText;
    submitButton.disabled = true;

    event.target.querySelector('div[data-customer-form-confirmation]').style.display = 'none';
    event.target.querySelector('div[data-customer-form-error]').style.display = 'none';
    //

    const emailAddress = emailField.value;
    const gender = document.getElementById("gender").value;
    const age = parseInt(document.getElementById("age").value);
    const weight = parseInt(document.getElementById("weight").value);
    const height = parseInt(document.getElementById("height").value);
    const activity = parseFloat(document.getElementById("activity").value);

    let goal = document.getElementById("goal").value;
    let gadgetGoal = goal;

    // Calculate original BMR
    const bmr = calculateBMR(gender, age, weight, height);

    // Calculate BMI and determine BMI-factor
    //const bmi = calculateBMI(weight, height);
    //const bmiFactor = determineBMIFactor(bmi);

    // Adjust BMR with BMI-factor
    const adjustedBMR = bmr;
    const result = calculateNutrition(age, weight, height, gender, activity, goal);

    // // Calculate other values using adjusted BMR
    // const dbh = calculateWM(adjustedBMR, activity);
    // const wl = calculateWL(adjustedBMR, activity);
    // const dry = calculateDry(adjustedBMR, activity);
    // const gain = calculateGain(adjustedBMR, activity);
    // var goalResult;
    // switch (goal) {
    //     case 'wl':
    //         gadgetGoal = 'lose_weight';
    //         goalResult = getGoalResultsForGadget(wl, weight, 'wl');
    //         break;
    //     case 'dry':
    //         gadgetGoal = 'lean_muscle';
    //         goalResult = getGoalResultsForGadget(dry, weight, 'dry');
    //         break;
    //     case 'gain':
    //         gadgetGoal = 'gain_weight';
    //         goalResult = getGoalResultsForGadget(gain, weight, 'gain');
    //         break;
    // }

    const calorie = Math.round(result.targetCalories);
    const fat = Math.round(result.macronutrients.fatGrams);
    const protein = Math.round(result.macronutrients.proteinGrams);
    const carbohydrate = Math.round(result.macronutrients.carbGrams);
    
     const options = {
        method: 'POST',
        headers: { revision: '2024-02-15', 'content-type': 'application/json' },
        body: JSON.stringify({
            data: {
                type: 'subscription',
                attributes: {
                    custom_source: 'Calorie Calculator',
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: emailAddress,
                                properties: {
                                    "gender": gender,
                                    "age": age,
                                    "height": height,
                                    "weight": weight,
                                    "calorie": calorie+' kcal',
                                    "fat": fat+' g',
                                    "protein": protein+' g',
                                    "carbohydrate": carbohydrate+' g'                                  
                                }
                            }
                        }
                    }
                },
                relationships: { list: { data: { type: 'list', id: 'SQfKwP' } } }
            }
        })
      };

    //console.log(options,'options data');
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UaPJ77', options)
    .then(response => {         
          console.log('Response code:', response.status); // Log the response code
          
          document.querySelector('div[data-customer-form]').style.display = 'none';
          document.querySelector('.hide-when-done').style.display = 'none';      
          document.querySelector('div[data-customer-form-confirmation]').style.display = 'block';
        return response;
    })
    .then(response => {
        console.log('Response data:', response); // Log the response data
          document.querySelector('div[data-customer-form]').style.display = 'none';
          document.querySelector('.hide-when-done').style.display = 'none'; 
          document.querySelector('div[data-customer-form-confirmation]').style.display = 'block';
    });  

});

// Add event listener to the select element
document.getElementById("goal").addEventListener("change", filterProducts);

// Initial filtering when the page loads
filterProducts();